import { useState } from 'react';
import { Buildings, ClipboardText, ShieldCheck, ChartLineUp } from '@phosphor-icons/react';
import { useAuth } from '../auth/AuthContext';
import { apiError } from '../lib/api';
import { Field, SubmitButton } from '../components/ui';

export default function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [pending, setPending] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim() || !password) {
      setError('Enter your email and password');
      return;
    }
    setError('');
    setPending(true);
    try {
      await login(email.trim(), password);
      // The route guard swaps this page out once `admin` is set.
    } catch (err) {
      setError(apiError(err, 'Could not sign in'));
      setPending(false);
    }
  };

  return (
    <div className="auth">
      <div className="auth-split">
        {/* What this console is. Hidden below 860px — it is context, not
            instruction, and stacking it would push the form off the fold. */}
        <aside className="auth-aside" aria-hidden="true">
          <div style={{ display: 'flex', alignItems: 'center', gap: 11, position: 'relative' }}>
            <div className="sidebar-mark">
              <Buildings size={20} weight="fill" />
            </div>
            <div>
              <h1 style={{ fontSize: 18, color: 'var(--paper)' }}>Estate Hub</h1>
              <p
                style={{
                  margin: '2px 0 0',
                  fontSize: 11,
                  letterSpacing: 0.4,
                  textTransform: 'uppercase',
                  color: 'rgba(255,255,255,0.6)',
                }}
              >
                Admin Console
              </p>
            </div>
          </div>

          <div style={{ position: 'relative' }}>
            <h2 style={{ fontSize: 23, lineHeight: 1.28, color: 'var(--paper)', margin: '0 0 10px' }}>
              The platform side of Estate Hub.
            </h2>
            <p style={{ fontSize: 13, lineHeight: 1.6, color: 'rgba(255,255,255,0.72)', margin: 0 }}>
              Every agency on the platform is reviewed, onboarded and billed from
              here.
            </p>
          </div>

          <div className="auth-aside-points">
            <span className="auth-point">
              <ClipboardText size={17} weight="regular" />
              Review who is asking to join, and onboard them
            </span>
            <span className="auth-point">
              <ChartLineUp size={17} weight="regular" />
              Set plans, record payments, see what is due
            </span>
            <span className="auth-point">
              <ShieldCheck size={17} weight="regular" />
              Open an agency read-only when they need help
            </span>
          </div>
        </aside>

        <div className="auth-form">
          {/* The brand only appears here on narrow screens, where the panel
              carrying it is hidden. */}
          <div className="auth-form-brand">
            <div className="sidebar-mark">
              <Buildings size={20} weight="fill" />
            </div>
            <div>
              <h1 style={{ fontSize: 18 }}>Estate Hub</h1>
              <p
                className="t-xs muted"
                style={{ margin: '2px 0 0', letterSpacing: 0.4, textTransform: 'uppercase' }}
              >
                Admin Console
              </p>
            </div>
          </div>

          <h2 style={{ fontSize: 20, marginBottom: 5 }}>Sign in</h2>
          <p className="t-sm muted" style={{ margin: '0 0 20px', lineHeight: 1.55 }}>
            This console manages every agency on the platform.
          </p>

          <form onSubmit={submit} noValidate className="stack" style={{ gap: 14 }}>
          <Field label="Email">
            <input
              className="input"
              name="email"
              type="email"
              autoComplete="username"
              autoCapitalize="none"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@estatehub.in"
            />
          </Field>

          <Field label="Password">
            <input
              className="input"
              name="password"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••••"
            />
          </Field>

          {error && (
            <p className="field-error" role="alert" style={{ margin: 0 }}>
              {error}
            </p>
          )}

          <SubmitButton
            type="submit"
            pending={pending}
            pendingLabel="Signing in…"
            className="btn btn-primary"
            style={{ justifyContent: 'center', width: '100%', padding: '12px 16px' }}
          >
              Sign in
            </SubmitButton>
          </form>
        </div>
      </div>
    </div>
  );
}
